// src/services/snapshots.service.ts
import { api } from './api';

export interface SnapshotEstadoRequisito {
  [requisitoId: string]: [estadoActual: 'C' | 'NC' | 'CP' | 'NA' | null, estadoAsesoria: 'C' | 'NC' | 'CP' | 'NA' | null];
}

export interface Snapshot {
  id: number;
  empresaId: string;
  fecha: string;
  fechaDia: string;
  estadosRequisitos: SnapshotEstadoRequisito;
}

export interface SnapshotHistorialResponse {
  success: boolean;
  data: Snapshot[];
}

export interface SnapshotByFechaResponse {
  success: boolean;
  data: Snapshot | null;
}

export interface CountSnapshotsResponse {
  success: boolean;
  data: {
    count: number;
  };
}

export interface SnapshotFilters {
  fechaInicio?: string;
  fechaFin?: string;
}

export const snapshotsService = {
  /**
   * Obtiene el historial completo de snapshots de una empresa
   */
  async getHistorial(nit: string, filters?: SnapshotFilters): Promise<SnapshotHistorialResponse> {
    const params = new URLSearchParams();
    if (filters?.fechaInicio) params.append('fechaInicio', filters.fechaInicio);
    if (filters?.fechaFin) params.append('fechaFin', filters.fechaFin);

    const queryString = params.toString();
    const url = `/empresas/${nit}/snapshots/historial${queryString ? `?${queryString}` : ''}`;

    return api.get<SnapshotHistorialResponse>(url);
  },

  /**
   * Obtiene el último snapshot de una empresa
   */
  async getUltimo(nit: string): Promise<SnapshotByFechaResponse> {
    return api.get<SnapshotByFechaResponse>(`/empresas/${nit}/snapshots/ultimo`);
  },

  /**
   * Obtiene un snapshot específico por fecha
   */
  async getByFecha(nit: string, fecha: string): Promise<SnapshotByFechaResponse> {
    return api.get<SnapshotByFechaResponse>(`/empresas/${nit}/snapshots/${fecha}`);
  },

  /**
   * Cuenta los snapshots de una empresa
   */
  async count(nit: string, filters?: SnapshotFilters): Promise<CountSnapshotsResponse> {
    const params = new URLSearchParams();
    if (filters?.fechaInicio) params.append('fechaInicio', filters.fechaInicio);
    if (filters?.fechaFin) params.append('fechaFin', filters.fechaFin);

    const queryString = params.toString();
    const url = `/empresas/${nit}/snapshots/count${queryString ? `?${queryString}` : ''}`;

    return api.get<CountSnapshotsResponse>(url);
  },
};
